class ParallaxVideo extends HTMLElement {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    window.setTimeout(() => {
      this.setAttribute('active', '')
    }, 500)

    this.setupListeners()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItem()
  }

  moveParallaxItem () {
    if (!this.offsetHeight) return

    const amountToMoveY = 30
    const elementHeight = this.offsetHeight

    const scaledItemHeight = elementHeight + amountToMoveY
    const heightDifference = scaledItemHeight - elementHeight

    const elementStartPoint = this.offsetTop - window.innerHeight
    const elementEndPoint = this.offsetTop + elementHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.style.transform = `translateY(${amountToMoveY / -2}px)`

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.transform = `translateY(${amountToMoveY / 2}px)`

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountY =
      heightDifference * scrollYAsAPercentageOfJourney - heightDifference / 2

    this.style.transform = `translateY(${transformAmountY}px)`
  }
}

if (!customElements.get('parallax-video')) {
  customElements.define('parallax-video', ParallaxVideo)
}
